import { defineComponent } from "@vue/composition-api";
import { OpenSurvey } from "@components/studies";

const Page = defineComponent({
	render(){
		return <OpenSurvey/>
	}
});

export default Page;